import React from "react";
import ContactUs from "../../Templates/Common/ContactUs";
import Detail from "../../Templates/DetailPage/Detail";
// import TopChoice from "../../Templates/DetailPage/TopChoice";

function DetailPage() {
  return (
    <div>
      <Detail />
      {/* <TopChoice /> */}
      <ContactUs />
    </div>
  );
}

export default DetailPage;
